import CustomDrawer from "@/components/drawer";
import { MerchantServiceCategoryDto, UserAppointmentsDto } from "@/models/club";
import { Customer } from "@/models/response/customer";
import useCreateAppointment from "@/services/appointment/hooks/useCreateAppointment";
import {
  ActionIcon,
  Blockquote,
  Box,
  Button,
  Card,
  Divider,
  Group,
  Image,
  Stack,
  Switch,
  Text
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { notifications } from "@mantine/notifications";
import { IconChevronDown, IconPlus, IconTrash } from "@tabler/icons-react";
import moment from "moment-jalaali";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CustomerInfo from "./CustomerInfo";
import EditDate from "./EditDate";
import EditTime from "./EditTime";
import SelectService from "./SelectService";
import TimeInfo from "./TimeInfo";
import { SelectedMerchantServiceDto } from "./type";

type Props = {
  opened: boolean;
  close: () => void;
  selectedCustomer: Customer;
  openCustomer: () => void;
  selectedDate: moment.Moment;
  currentTime: string;
  setSelectedDate: (date: moment.Moment) => void;
  setCurrentTime: (time: string) => void;
  selectedPartner: UserAppointmentsDto | null;
  setSelectedCustomer: (customer: Customer | null) => void;
};

function AddAppointment({
  opened,
  close,
  selectedCustomer,
  openCustomer,
  selectedDate,
  currentTime,
  setSelectedDate,
  setCurrentTime,
  selectedPartner,
  setSelectedCustomer,
}: Props) {
  const { cId } = useParams();
  const { mutate, isLoading } = useCreateAppointment();
  const navigate = useNavigate();
  const [openedCalender, { open: openCalender, close: closeCalender }] =
    useDisclosure(false);
  const [openedTime, { open: openTime, close: closeTime }] =
    useDisclosure(false);
  const [openedServices, { open: openServices, close: closeServices }] =
    useDisclosure(false);
  const [isConfirmed, setIsConfirmed] = useState(false);

  const [selectedServices, setSelectedServices] = useState<
    SelectedMerchantServiceDto[] | null
  >(null);

  const [selectedMerchantServiceCategory, setSelectedMerchantServiceCategory] =
    useState<MerchantServiceCategoryDto | undefined>(undefined);

  const handleSubmit = () => {
    if (!selectedCustomer) {
      // notifications.show({
      //   message: "لطفا مشتری را انتخاب نمایید",
      //   color: "yellow",
      // });
      openCustomer();
      return;
    }
    mutate(
      {
        customerId: selectedCustomer?.id,
        description: "",
        merchantServiceId: selectedMerchantServiceCategory?.id,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        services: selectedServices?.map((service) => ({
          merchantServiceId: service?.id,
          count: 1,
          date: moment(selectedDate).format("YYYY-MM-DD"),
          merchantUserId: selectedPartner?.user?.id,
          startTime: service?.startTime + ":00",
        })),
        isConfirmed: !isConfirmed,
      },
      {
        onSuccess() {
          notifications.show({
            title: "عملیات موفق",
            message: "عملیات با موفقیت صورت پذیرفت",
            color: "green",
          });
          navigate(-1);
        },
      }
    );
  };

  const closeModal = () => {
    if (!opened) {
      setSelectedServices(null);
      setSelectedMerchantServiceCategory(undefined);
      if (!cId) setSelectedCustomer(null);
    }
    close();
  };

  const recalcStartTimesFrom = (
    services: SelectedMerchantServiceDto[],
    startFrom: string
  ): SelectedMerchantServiceDto[] =>
    services.reduce<SelectedMerchantServiceDto[]>((acc, service, i) => {
      if (i === 0) {
        acc.push({ ...service, startTime: startFrom });
      } else {
        const prev = acc[i - 1];
        const endTime = moment()
          .startOf("day")
          .add(moment.duration(prev.startTime))
          .add(prev.durationPartInMinute, "minutes")
          .format("HH:mm");
        acc.push({ ...service, startTime: endTime });
      }
      return acc;
    }, []);

  const handleRemoveService = (index: number) => {
    const remaining =
      selectedServices?.filter((_, i) => i !== index) ?? null;
    if (!remaining?.length) {
      setSelectedServices(null);
      setSelectedMerchantServiceCategory(undefined);
      return;
    }
    setSelectedServices(recalcStartTimesFrom(remaining, currentTime));
  };

  useEffect(() => {
    if (currentTime && selectedServices && selectedServices.length > 0) {
      // Build updated services sequentially, each based on the previous one
      const updatedServices = selectedServices.reduce<
        SelectedMerchantServiceDto[]
      >((acc, service, index) => {
        if (index === 0) {
          // First service starts at currentTime
          acc.push({ ...service, startTime: currentTime });
        } else {
          // Subsequent services start at previous service's end time
          const previousService = acc[index - 1];
          const previousStartTime = previousService.startTime;
          const previousDuration = previousService.durationPartInMinute;

          // Calculate end time by adding duration to start time
          const endTime = moment()
            .startOf("day")
            .add(moment.duration(previousStartTime))
            .add(previousDuration, "minutes")
            .format("HH:mm");

          acc.push({ ...service, startTime: endTime });
        }
        return acc;
      }, []);

      setSelectedServices(updatedServices);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTime]);

  return (
    <>
      {/* <Modal opened={opened && !isSmall} onClose={close}>
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <Box
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
            }}
            px="md"
          >
            <Group gap="5" onClick={openCalender} h="70px">
              <Text fw="bold" size="lg">
                {moment(selectedDate).format("dddd jD jMMMM")}
              </Text>
              <IconChevronDown stroke={1} />
            </Group>
            <Divider />
            <Stack py="sm">
              <CustomerInfo
                selectedCustomer={selectedCustomer}
                openCustomer={openCustomer}
              />
            </Stack>

            <TimeInfo
              currentDate={selectedDate}
              currentTime={currentTime}
              openCalender={openCalender}
              openTime={openTime}
            />
            <Text size="md" fw="500" pt="lg">
              خدمات
            </Text>
            {selectedServices?.length && selectedServices?.length > 0 ? (
              <>
                <Stack>
                  {selectedServices?.map((service, index) => (
                    <Blockquote
                      key={service?.id}
                      color="blue"
                      bg="white"
                      p="xs"
                    >
                      <Group justify="space-between">
                        <Stack gap="xs">
                          <Text size="sm" fw="500">
                            {service?.title}
                          </Text>
                          <Group gap="xs">
                            <Text size="xs" c="dimmed">
                              {service?.startTime}
                            </Text>
                            <Text c="dimmed">-</Text>
                            <Text size="xs" c="dimmed">
                              {service?.durationPartInMinute} دقیقه
                            </Text>
                            <Text c="dimmed">-</Text>
                            <Text size="xs" c="dimmed">
                              {selectedPartner?.user?.firstName}
                            </Text>
                          </Group>
                        </Stack>
                        <ActionIcon
                          variant="transparent"
                          color="red"
                          onClick={() => handleRemoveService(index)}
                        >
                          <IconTrash stroke={1} size={20} />
                        </ActionIcon>
                      </Group>
                    </Blockquote>
                  ))}
                </Stack>
                <Button
                  variant="outline"
                  radius="lg"
                  color="dark"
                  leftSection={<IconPlus size={15} />}
                  size="xs"
                  onClick={openServices}
                  w="fit-content"
                  my="lg"
                >
                  افزودن خدمت
                </Button>
              </>
            ) : (
              <Card withBorder mih={200}>
                <Stack justify="center" align="center">
                  <Image
                    w={80}
                    src={
                      new URL(
                        "@/assets/images/service/serviceItem.png",
                        import.meta.url
                      ).href
                    }
                    alt="service"
                  />
                  <Text size="xs" c="dimmed">
                    برای ذخیره قرار ملاقات، سرویسی اضافه کنید
                  </Text>
                  <Button
                    variant="outline"
                    radius="lg"
                    color="dark"
                    leftSection={<IconPlus size={15} />}
                    size="xs"
                    onClick={openServices}
                  >
                    <Text size="xs">افزودن خدمت</Text>
                  </Button>
                </Stack>
              </Card>
            )}
          </Box>

          <Card
            styles={{
              root: {
                position: "sticky",
                bottom: 0,
                zIndex: 10,
              },
            }}
            withBorder
            radius={0}
          >
            <Button
              size="lg"
              fullWidth
              type="submit"
              color="dark"
              form="add-category"
              onClick={handleSubmit}
              loading={isLoading}
              disabled={
                selectedServices?.length && selectedServices?.length > 0
                  ? false
                  : true
              }
            >
              افزودن
            </Button>
          </Card>
        </Box>
      </Modal> */}
      <CustomDrawer
        opened={opened}
        onClose={close}
        close={closeModal}
        position="left"
        radius="md"
        custom="add-appointment"
        title=""
        size="xl"
        zIndex={100}
        p="0"
        styles={{
          body: {
            padding: 0,
          },
        }}
      >
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            minHeight: "91svh",
          }}
        >
          <Box
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
            }}
            px="md"
          >
            <Group gap="5" onClick={openCalender} h="70px">
              <Text fw="bold" size="lg">
                {moment(selectedDate).format("dddd jD jMMMM")}
              </Text>
              <IconChevronDown stroke={1} />
            </Group>
            <Divider />
            <Stack py="sm">
              <CustomerInfo
                selectedCustomer={selectedCustomer}
                openCustomer={openCustomer}

              />
            </Stack>

            <TimeInfo
              currentDate={selectedDate}
              currentTime={currentTime}
              openCalender={openCalender}
              openTime={openTime}
            />
            <Text size="md" fw="500" pt="lg">
              خدمات
            </Text>
            {selectedServices?.length && selectedServices?.length > 0 ? (
              <>
                <Stack>
                  {selectedServices?.map((service, index) => (
                    <Blockquote
                      key={service?.id}
                      color="blue"
                      bg="white"
                      p="xs"
                    >
                      <Group justify="space-between">
                        <Stack gap="xs">
                          <Text size="sm" fw="500">
                            {service?.title}
                          </Text>
                          <Group gap="xs">
                            <Text size="xs" c="dimmed">
                              {service?.startTime}
                            </Text>
                            <Text c="dimmed">-</Text>
                            <Text size="xs" c="dimmed">
                              {service?.durationPartInMinute} دقیقه
                            </Text>
                            <Text c="dimmed">-</Text>
                            <Text size="xs" c="dimmed">
                              {selectedPartner?.user?.firstName}
                            </Text>
                          </Group>
                        </Stack>
                        <ActionIcon
                          variant="transparent"
                          color="red"
                          onClick={() => handleRemoveService(index)}
                        >
                          <IconTrash stroke={1} size={20} />
                        </ActionIcon>
                      </Group>
                    </Blockquote>
                  ))}
                </Stack>
                <Button
                  variant="outline"
                  radius="lg"

                  leftSection={<IconPlus size={15} />}
                  size="xs"
                  onClick={openServices}
                  w="fit-content"
                  my="lg"
                >
                  افزودن خدمت
                </Button>
              </>
            ) : (
              <Card withBorder mih={200}>
                <Stack justify="center" align="center">
                  <Image
                    w={80}
                    src={
                      new URL(
                        "@/assets/images/service/serviceItem.png",
                        import.meta.url
                      ).href
                    }
                    alt="service"
                  />
                  <Text size="xs" c="dimmed">
                    برای ذخیره قرار ملاقات، سرویسی اضافه کنید
                  </Text>
                  <Button
                    variant="outline"
                    radius="lg"

                    leftSection={<IconPlus size={15} />}
                    size="xs"
                    onClick={openServices}
                  >
                    <Text size="xs">افزودن خدمت</Text>
                  </Button>
                </Stack>
              </Card>
            )}
          </Box>

          <Card
            styles={{
              root: {
                position: "sticky",
                bottom: 0,
                zIndex: 10,
              },
            }}
            withBorder
            radius={0}
          >
            <Stack>
              <Switch
                defaultChecked
                label="ارسال لینک پرداخت بیعانه"
                checked={isConfirmed}
                onChange={(event) => setIsConfirmed(event.currentTarget.checked)}
              />
              <Button
                size="lg"
                fullWidth
                type="submit"

                form="add-category"
                onClick={handleSubmit}
                loading={isLoading}
                disabled={
                  selectedServices?.length && selectedServices?.length > 0
                    ? false
                    : true
                }
              >
                افزودن
              </Button>
            </Stack>

          </Card>
        </Box>
      </CustomDrawer>

      <EditDate
        openedCalender={openedCalender}
        closeCalender={closeCalender}
        setSelectedDate={setSelectedDate}
      />

      <EditTime
        openedTime={openedTime}
        closeTime={closeTime}
        currentTime={currentTime}
        setCurrentTime={setCurrentTime}
      />

      <SelectService
        closeService={closeServices}
        previewServices={openedServices}
        selectedServices={selectedServices || []}
        setSelectedServices={setSelectedServices}
        selectedMerchantServiceCategory={selectedMerchantServiceCategory}
        setSelectedMerchantServiceCategory={setSelectedMerchantServiceCategory}
        selectedPartner={selectedPartner}
        currentTime={currentTime}
      />
    </>
  );
}

export default AddAppointment;
